export default {"src":"/_next/static/media/NOW.864ddfd5.svg","height":18,"width":18};